import menu from './menu';
import notifications from './notifications';

const pathname = window.location.pathname.replace(/^\//, '').replace(/\/$/, '');
let connection = window.env.CONNECTION || '';

const connections = [
    { id: 'filter-pro', name: 'Filter Pro', link: '/admin/filter-pro' },
    { id: 'nz-parts', name: 'NZ Parts', link: '/admin/nz-parts' },
    { id: 'united-trucks', name: 'United Trucks', link: '/admin/united-trucks' },
];
window.env.connections = connections;
window.env.apiPrefix = connection;

export default {
    rootPath: window.env.APP_URL,
    apiPrefix: connection,
    apiFullPrefix: connection ? `api/${connection}` : 'api',
    currentConnection: connection,
    connections: connections,
    cmsTitle: window.env.APP_NAME,
    cmsPath: connection ? `/admin/${connection}` : '/admin',
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '^/categories': {
                params: { filter: 'parent_id:$null', append: 'product_number' },
            },
            '^/customers': {
                params: { sort: 'name:asc' }
            },
            '^/customer_logins': {
                params: { sort: 'registered_at:desc' }
            },
            '^/enquiries': {
                params: { sort: 'enquiry_date:desc' }
            },
            '^/products': {
                params: { sort: 'partno:asc', append: 'category_list,make_model_count' },
                preserveQueryOnConnectionSwitch: true,
                excludeFiltersOnConnectionSwitch: ['brand_id', 'id'],
            },
            '^/product/[\\d]+$': {
                preserveQueryOnConnectionSwitch: true,
            },
            '^/product/[\\d]+/make_models': {
                params: { sort: 'make:asc;model:asc;yearfrom:asc;yearto:asc' },
                preserveQueryOnConnectionSwitch: true,
            },
            '^/lookup': {
                params: { sort: 'name:asc' },
                preserveQueryOnConnectionSwitch: true,
            },
            '^/make_models': {
                params: { sort: 'model:asc' },
                preserveQueryOnConnectionSwitch: true,
            },
            '^/orders': {
                params: { sort: 'order_date:desc' }
            },
            '^/order/[\\d]+$': {
                params: { include: 'items,customer,customer_login' },
                preserveQueryOnConnectionSwitch: false,
            },
            '^/order/[\\d]+/status$': {
                params: { sort: 'created_at:desc' }
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            csv: ['csv'],
        }
    },
    menu,
    notifications,
    inboxActive: false,
}
